














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ShareArrow extends Vue {
  @Prop({ default: '17' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: 'white' }) readonly color?: string;
}
